import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/blog/combien-coute-vide-maison-bruxelles/PageClient.jsx");
